import {getApi} from './../core/index';

export function getPOSInfo(language, params, apiKey = null) {
    return getApi(
        language,
        params,
        '/restaurant/dil/punti-di-servizio/info',
        apiKey,
    );
}
